/**
 *
 * Asynchronously loads the component for Roles
 *
 */

import { lazyLoad } from 'utils/loadable';

export const Roles = lazyLoad(
  () => import('./index'),
  module => module.Roles
);
